import { Link } from 'react-router-dom'
import { Row, Column } from '../../components'
import { Container } from 'react-bootstrap'
import Navbar from 'react-bootstrap/Navbar'
import * as label from '../../shared/util/label'

// Placeholder detail screen - the Campaign WorkFlow builder is not built yet.
const CampaignWorkFlowDetail = () => {
  return (
    <>
      <Row>
        <Column lg={12}>
          <Navbar className="bg-transparent">
            <Navbar.Brand>{label.CAMPAIGN_WORKFLOW_DETAIL.toUpperCase()}</Navbar.Brand>
          </Navbar>
        </Column>
      </Row>
      <div className='outerPanel card shadow-sm pb-3 border-top-0'>
        <Container fluid>
          <Row>
            <Column lg={12} className='text-center py-5'>
              <h5>{label.COMING_SOON}</h5>
              <p className='mb-0'>
                <Link to='/Campaign/CampaignWorkFlows' className='btn btn-link text-decoration-none'>
                  {label.BACK_TO_CAMPAIGN_WORKFLOWS}
                </Link>
              </p>
            </Column>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default CampaignWorkFlowDetail
